import { CommonModule } from '@angular/common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { YahooWarnModalComponent } from './yahoo-warn-modal.component';
import { YahooApplicationIdSettingResource } from '@blcloud/bl-ng-resource';
import { YahooLoginButtonModule } from '@blcloud/bl-ng-share-module';

@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    YahooLoginButtonModule.forRoot(),
  ],
  exports: [
    YahooWarnModalComponent,
  ],
  declarations: [
    YahooWarnModalComponent,
  ],
  entryComponents: [
    YahooWarnModalComponent,
  ],
  providers: [
    YahooApplicationIdSettingResource,
  ],
})
export class YahooWarnModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: YahooWarnModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-warn-modal/yahoo-warn-modal.module.ts